export function renderViewdocsHeader(icon, label) {
  document.getElementById('container-header').innerHTML = `<ewc-title icon="${icon}" label="${edicom.locale.translate(label)}" level="3"></ewc-title>`;
}
